import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaTachometerAlt, FaUsers, FaFileContract, FaCog, FaSignOutAlt,
  FaBuilding, FaMapMarkerAlt, FaCity, FaFlag,
  FaUserTie, FaUserCog, FaShieldAlt, FaBook, FaListAlt, FaHardHat,
  FaFileAlt, FaFolderOpen, FaStamp, FaBalanceScale, FaFileInvoiceDollar, FaSearch, FaPrint, FaWrench,
  FaChevronDown, FaChevronUp, FaLandmark
} from 'react-icons/fa';
import './Sidebar.css';

const SubMenu = ({ item, isOpen, isSubMenuOpen, toggleSubMenu }) => {
  const getLinkClass = ({ isActive }) => isActive ? 'menu-item active' : 'menu-item';

  return (
    <div className="menu-group">
      <div className="submenu-toggle" onClick={toggleSubMenu}>
        <div className="menu-item-content">
          <item.icon className="menu-icon" />
          {isOpen && <span className="menu-title">{item.title}</span>}
        </div>
        {isOpen && (isSubMenuOpen ? <FaChevronUp /> : <FaChevronDown />)}
      </div>
      {isSubMenuOpen && isOpen && (
        <div className="submenu">
          {item.children.map((child, index) => (
            <NavLink key={index} to={child.path} className={getLinkClass}>
              <child.icon className="menu-icon submenu-icon" />
              <span className="menu-title">{child.title}</span>
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
};


const Sidebar = ({ isOpen, onLogout }) => {
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const getLinkClass = ({ isActive }) => isActive ? 'menu-item active' : 'menu-item';

  const toggleSubMenu = (groupTitle) => {
    setOpenSubMenu(openSubMenu === groupTitle ? null : groupTitle);
  };

  const menuItems = [
    {
      group: 'Principal',
      items: [
        { path: '/dashboard', title: 'Dashboard', icon: FaTachometerAlt, exact: true }
      ]
    },
    {
      group: 'Tabelas de Referência',
      isSubMenu: true,
      icon: FaListAlt,
      title: 'Tabelas de Referência',
      children: [
        { path: '/dashboard/nucleos', title: 'Núcleos', icon: FaBuilding },
        { path: '/dashboard/bairros', title: 'Bairros', icon: FaMapMarkerAlt },
        { path: '/dashboard/cidades', title: 'Cidades', icon: FaCity },
        { path: '/dashboard/nacionalidades', title: 'Nacionalidades', icon: FaFlag },
        { path: '/dashboard/profissoes', title: 'Profissões', icon: FaUserTie },
        { path: '/dashboard/situacao-cadastral', title: 'Situação Cadastral', icon: FaUserCog },
        { path: '/dashboard/situacao-funcional', title: 'Situação Funcional', icon: FaUserCog },
        { path: '/dashboard/setores-funcional', title: 'Setores', icon: FaLandmark },
        { path: '/dashboard/departamentos', title: 'Departamentos', icon: FaBuilding },
        { path: '/dashboard/grau-de-instrucao', title: 'Grau de Instrução', icon: FaBook },
        { path: '/dashboard/tipo-de-enquadramento', title: 'Tipo de Enquadramento', icon: FaStamp },
        { path: '/dashboard/classificacao-enquadramento', title: 'Classificação Enquadramento', icon: FaStamp },
        { path: '/dashboard/orgaos-referencia', title: 'Órgão de Referência', icon: FaLandmark },
        { path: '/dashboard/unidade-medida', title: 'Unidade de Medida', icon: FaBalanceScale },
        { path: '/dashboard/orgao-especialidades', title: 'Órgão de Especialidades', icon: FaBuilding },
        { path: '/dashboard/diretrizes', title: 'Diretrizes', icon: FaListAlt },
        { path: '/dashboard/projetos', title: 'Projetos', icon: FaFolderOpen },
        { path: '/dashboard/documentacao-basica', title: 'Documentação Básica', icon: FaFileAlt },
        { path: '/dashboard/documentacao-tecnica', title: 'Documentação Técnica', icon: FaFileContract },
        { path: '/dashboard/tipo-logradouros', title: 'Tipo de Logradouros', icon: FaMapMarkerAlt },
        { path: '/dashboard/atividades-cnae', title: 'Atividades CNAE', icon: FaHardHat },
        { path: '/dashboard/instituicoes-formacao', title: 'Instituições de Formação', icon: FaBook },
        { path: '/dashboard/tipos-documentos', title: 'Tipos de Documentos', icon: FaFileAlt },
        { path: '/dashboard/status-processo', title: 'Status de Processo', icon: FaFileInvoiceDollar },
        { path: '/dashboard/prazos-validacao', title: 'Prazos de Validação', icon: FaFileContract },
        { path: '/dashboard/tipos-licenca', title: 'Tipos de Licença', icon: FaFileAlt },
        { path: '/dashboard/pareamento-leis', title: 'Pareamento das Leis', icon: FaBalanceScale },
        { path: '/dashboard/grau-poluidor', title: 'Grau Poluidor', icon: FaHardHat },
        { path: '/dashboard/area-empreendimento', title: 'Área do Empreendimento', icon: FaMapMarkerAlt },
        { path: '/dashboard/investimento-ufm', title: 'Investimento em UFM', icon: FaFileInvoiceDollar },
        { path: '/dashboard/texto-padrao', title: 'Texto Padrão', icon: FaFileAlt },
        { path: '/dashboard/quadro-funcional', title: 'Quadro Funcional', icon: FaUsers },
        { path: '/dashboard/faixa-licenciamento', title: 'Faixa de Licenciamento Mun.', icon: FaStamp },
      ]
    },
    {
      group: 'Cadastros',
      isSubMenu: true,
      icon: FaFileAlt,
      title: 'Cadastros',
      children: [
        { path: '/dashboard/indexadores', title: 'Indexadores', icon: FaBook },
        { path: '/dashboard/contribuintes', title: 'Contribuintes', icon: FaUsers },
        { path: '/dashboard/roteiro-orientativo', title: 'Roteiro Orientativo', icon: FaListAlt },
        { path: '/dashboard/tecnicos-ambientais', title: 'Técnicos Ambientais', icon: FaHardHat },
        { path: '/dashboard/atividade-secundaria', title: 'Atividade Secundária', icon: FaCog },
      ]
    },
    {
      group: 'Trâmite',
      isSubMenu: true,
      icon: FaFileAlt,
      title: 'Trâmite',
      children: [
        { path: '/dashboard/abertura-processo', title: 'Abertura de Processo', icon: FaFolderOpen },
        { path: '/dashboard/protocolo-padrao', title: 'Protocolo Padrão', icon: FaStamp },
        { path: '/dashboard/enquadramento', title: 'Enquadramento', icon: FaBalanceScale },
        { path: '/dashboard/dam', title: 'DAM', icon: FaFileInvoiceDollar },
      ]
    },

    {
      group: 'Consultas',
      isSubMenu: true,
      icon: FaSearch,
      title: 'Consultas',
      children: [
        { path: '/dashboard/consulta-roteiro', title: 'Roteiro Orientativo', icon: FaListAlt },
        { path: '/dashboard/consulta-processos', title: 'Processos', icon: FaFolderOpen },
      ]
    },
    {
      group: 'Impressões',
      isSubMenu: true,
      icon: FaPrint,
      title: 'Impressões',
      children: [
        { path: '/dashboard/impressao-processo', title: 'Processo', icon: FaFolderOpen },
        { path: '/dashboard/impressao-licenca', title: 'Licença', icon: FaFileAlt },
      ]
    },
    {
      group: 'Utilidades',
      isSubMenu: true,
      icon: FaWrench,
      title: 'Utilidades',
      children: [
        { path: '/dashboard/dados-orgao', title: 'Dados do Órgão', icon: FaLandmark },
        { path: '/dashboard/usuarios', title: 'Usuários', icon: FaUserCog },
        { path: '/dashboard/niveis-acesso', title: 'Níveis de Acesso', icon: FaShieldAlt },
      ]
    },
    // Adicione outros grupos de menu aqui
  ];

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <NavLink to="/dashboard" className="logo-gma">
          <FaLandmark />
          {isOpen && <span>GMA</span>}
        </NavLink>
      </div>

      <div className="sidebar-content">
        <nav>
          {menuItems.map((group, index) => (
            <div key={index}>
              {group.isSubMenu ? (
                <SubMenu 
                  item={group} 
                  isOpen={isOpen}
                  isSubMenuOpen={openSubMenu === group.title}
                  toggleSubMenu={() => toggleSubMenu(group.title)}
                />
              ) : (
                <div className="menu-group">
                  {isOpen && <span className="menu-group-title">{group.group}</span>}
                  {group.items.map((item, itemIndex) => (
                    <NavLink key={itemIndex} to={item.path} end={item.exact} className={getLinkClass}>
                      <item.icon className="menu-icon" />
                      <span className="menu-title">{item.title}</span>
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>

      <div className="sidebar-footer">
        <button className="logout-button" onClick={onLogout}>
          <FaSignOutAlt className="menu-icon" />
          {isOpen && <span className="menu-title">Sair</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
